<template>
  <div class="main-container">
    <div class="bread" v-if="!!$route.query.recommend">
      <router-link :to="{ name: 'Index' }">
        {{ $t('common.indexPage') }}
      </router-link>
      <span class="slash">/</span>
      <span class="current">{{ $route.query.title }}</span>
    </div>
    <SearchKeyWords></SearchKeyWords>
    <Classify
      class="classify"
      :class="{
        'classify-top': !$route.query.recommend && !$route.query.keywords,
      }"
      :items="[
        {
          id: 'classify',
          name: $t('common.classify'),
          value: { item: classify, child: sub_classify },
          children: classifyList,
        },
      ]"
      @change="onClassifyChange"
    ></Classify>
    <ul class="sort clearfix">
      <li :class="{ active: sort == '' }" @click="changeSort('')">
        {{ $t('common.default') }}
      </li>
      <li :class="{ active: sort == 'id' }" @click="changeSort('id')">
        {{ $t('common.newest') }}
      </li>
      <li :class="{ active: sort == 'hot' }" @click="changeSort('hot')">
        {{ $t('common.hot') }}
      </li>
      <li
        class="sort-price"
        :class="{
          active: sort == 'price',
          desc: sort == 'price' && direct == 'desc',
          asc: sort == 'price' && direct == 'asc',
        }"
        @click="changeSort('price')"
      >
        {{ $t('common.price') }}
      </li>
    </ul>
    <List
      class="list"
      ref="list"
      url="/api/app/ebook/"
      :search="{
        classify_id: this.sub_classify || this.classify,
        order: sort,
        sort: direct,
        recommend: $route.query.recommend,
        keywords: this.$route.query.keywords,
      }"
      :limit="15"
      :alwaysShowPager="true"
    >
      <template v-slot="{ list }">
        <div class="clearfix" v-if="list.length">
          <EbooksItem
            class="goods-item"
            v-for="item in list"
            :key="item.id"
            :item="item"
          ></EbooksItem>
        </div>
        <Empty v-if="list.length == 0" class="empty" :title="$t('goods.empty')" />
      </template>
    </List>
  </div>
</template>
<script>
import List from '@/components/List.vue';
import EbooksItem from '@/components/EbooksItem';
import Classify from '../../components/Classify.vue';
import SearchKeyWords from '@/modules/stu/components/SearchKeyWords.vue';

export default {
  name: 'Ebooks',
  components: {
    List,
    EbooksItem,
    Classify,
    SearchKeyWords,
  },
  data() {
    return {
      classify: 0,
      sub_classify: 0,
      classifyList: [],
      searchCondition: {
        order: '',
        sort: 'desc',
        recommend: this.$route.query.recommend,
      },
    };
  },
  computed: {
    sort() {
      return this.searchCondition.order;
    },
    direct() {
      return this.searchCondition.sort;
    },
  },
  watch: {
    $route() {
      this.$refs.list.searchRefresh();
    },
  },
  async created() {
    this.classifyList = await this.$http.get('/api/app/ebook/classify');
    this.classifyList.forEach((item) => {
      item.name = item.title;
      item.child &&
        item.child.forEach((child) => {
          child.name = child.title;
        });
    });
  },
  methods: {
    async onClassifyChange({ value }) {
      this.classify = value.item;
      this.sub_classify = value.child;
      this.$refs.list.searchRefresh();
    },
    async changeSort(sort) {
      this.searchCondition.order = sort;
      if (sort == 'price') {
        this.searchCondition.sort = this.searchCondition.sort == 'desc' ? 'asc' : 'desc';
      } else {
        this.searchCondition.sort = 'desc';
      }
      this.$refs.list.searchRefresh();
    },
  },
};
</script>
<style lang="scss" scoped>
.classify-top {
  margin-top: 20px;
}
.select-tab-wrap {
  margin-top: 30px;
}
.goods-classify-search {
  ::v-deep {
    .item {
      .left {
        width: 42px;
      }
    }
  }
}
.sort {
  padding: 12px 0;
  li {
    float: left;
    font-size: 14px;
    color: #666;
    line-height: 22px;
    cursor: pointer;
    margin-left: 24px;
    &.active {
      color: $primary-color;
    }
    &:first-child {
      margin-left: 0 !important;
    }
    &.sort-price {
      position: relative;
      &::after {
        content: '';
        width: 12px;
        height: 14px;
        position: absolute;
        background-size: 100% 100%;
        background-image: url('~@/assets/images/common/sort@2x.png');
        top: 4px;
        right: -17px;
      }

      &.asc::after {
        background-image: url('~@/assets/images/common/sort-asc@2x.png');
      }

      &.desc::after {
        background-image: url('~@/assets/images/common/sort-desc@2x.png');
      }
    }
  }
}
.list {
  ::v-deep {
    .pager {
      margin-top: 10px !important;
    }
  }
  .goods-item {
    border: none;
  }
}
.main-container {
  padding-bottom: 46px;
}
.empty {
  margin-bottom: 50px;
}
</style>
